import '../../src/js/components/tabs';
